import { createSlice } from "@reduxjs/toolkit";
import { fetchEventUpdateSocket } from "./systemDuck";

export const settingsUIDefaultState = {
  autoZero: {
    isRunManuallyBtnDisabled: false,
  },
  qal3: {
    isRunManuallyBtnDisabled: false,
  },
  showLinearGauges: false,
  showDeviceTags: false,
  showEdgeUnitStatusPanel: false,
  showEdgeUnitStatusPanelCPUData: false,
};

const settingsUISlice = createSlice({
  name: "settingsUI",
  initialState: settingsUIDefaultState,
  reducers: {
    setAutoZeroRunManuallyBtnStatus(state, action) {
      state.autoZero.isRunManuallyBtnDisabled = action.payload.data.isDisabled;
    },
    setQal3RunManuallyBtnStatus(state, action) {
      state.qal3.isRunManuallyBtnDisabled = action.payload.data.isDisabled;
    },
    toggleLinearGauges(state) {
      state.showLinearGauges = !state.showLinearGauges;
    },
    toggleDeviceTags(state) {
      state.showDeviceTags = !state.showDeviceTags;
    },
    toggleEdgeUnitInfoPanel(state, action) {
      state.showEdgeUnitStatusPanel = !state.showEdgeUnitStatusPanel;
    },
    toggleEdgeUnitStatusPanelCPUData(state, action) {
      state.showEdgeUnitStatusPanelCPUData = !state.showEdgeUnitStatusPanelCPUData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEventUpdateSocket, (state, action) => {
      const { Element: element, Reason: reason } = action.payload.data;
      if (element === "AutoZero") {
        // AUTOZERO START/STOP BUTTON STATE HANDLING ACCORDING TO ROUTINE-RUN STATUS MESSAGES
        if (reason.includes("started")) {
          state.autoZero.isRunManuallyBtnDisabled = true;
        } else if (
          reason.includes("resumed") ||
          reason.includes("resumed from failure") ||
          reason.includes("finished")
        ) {
          state.autoZero.isRunManuallyBtnDisabled = false;
        }
      } else if (element === "QAL3") {
        // QAL3 START/STOP BUTTON STATE HANDLING ACCORDING TO ROUTINE-RUN STATUS MESSAGES
        if (reason.includes("started")) {
          state.qal3.isRunManuallyBtnDisabled = true;
        } else if (
          reason.includes("resumed") ||
          reason.includes("resumed from failure") ||
          reason.includes("finished")
        ) {
          state.qal3.isRunManuallyBtnDisabled = false;
        }
      }
    });
  },
});

export const {
  setAutoZeroRunManuallyBtnStatus,
  setQal3RunManuallyBtnStatus,
  toggleLinearGauges,
  toggleDeviceTags,
  toggleEdgeUnitInfoPanel,
  toggleEdgeUnitStatusPanelCPUData,
} = settingsUISlice.actions;

export default settingsUISlice.reducer;
